import { useCallback } from 'preact/hooks';
import { usePress } from '../hooks/UNSAFE_usePress';
import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';
import { clearIconStyles } from './ClearIconStyles.css';
import { classNames } from '../utils/UNSAFE_classNames';
import { useComponentTheme } from '#hooks/UNSAFE_useComponentTheme';
import { ButtonLayoutRedwoodTheme } from '#UNSAFE_ButtonLayout/themes/redwood/ButtonLayoutTheme';

type Props = {
  onClick?: () => void;
};

const noop = () => {};

export function ClearIcon({ onClick }: Props) {
  const killEvent = useCallback((event: Event) => {
    event.preventDefault();
  }, []);
  const { pressProps } = usePress(onClick ?? noop);
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  const clearStr = translations.formControl_clear();

  // Because the ClearIconStyles.css.ts uses buttonLayoutBaseTheme styles, we
  // need their vars to be loaded as well. This is why we are adding the buttonLayoutBaseTheme
  // style class.
  // TODO: update ButtonLayoutRedwoodTheme once theme switching is re-enabled.
  const { baseTheme: buttonLayoutBaseTheme } = useComponentTheme(ButtonLayoutRedwoodTheme);
  const styleClasses = classNames([buttonLayoutBaseTheme, clearIconStyles]);
  return (
    <span
      aria-hidden="true"
      class={styleClasses}
      tabIndex={-1}
      onMouseDown={killEvent}
      title={clearStr}
      {...pressProps}>
      <svg height="1em" viewBox="0 0 24 24" width="1em" xmlns="http://www.w3.org/2000/svg">
        <path
          d="m12 1c6.065 0 11 4.935 11 11s-4.935 11-11 11-11-4.935-11-11 4.935-11 11-11zm3.4979817 6-3.4979817 3.498-3.49798173-3.498-1.50201827 1.50201827 3.498 3.49798173-3.498 3.4979817 1.50201827 1.5020183 3.49798173-3.498 3.4979817 3.498 1.5020183-1.5020183-3.498-3.4979817 3.498-3.49798173z"
          fill="currentcolor"
          fill-rule="evenodd"
        />
      </svg>
    </span>
  );
}
